import script from "./courseCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./courseCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./courseCheckbox.vue?vue&type=style&index=0&id=9ac1873e&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ac1873e"]])

export default __exports__